import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { DataEHoraAmigavel } from '@/shared/utils/datas';

export type EstadoTarefaModal = 'sem_tarefa' | 'em_atendimento' | 'atendida';

interface ModalTarefaNotificacaoProps {
  show: boolean;
  titulo: string;
  estado: EstadoTarefaModal;
  editadoPorNome?: string;
  editadoEm?: string;
  onHide: () => void;
  onCriarTarefa: (concluida: boolean) => void;
  onAtender: () => void;
  loading?: boolean;
}

function MensagemAutoria({ prefixo, editadoPorNome, editadoEm }: { prefixo: string; editadoPorNome?: string; editadoEm?: string; }) {

  if (!editadoPorNome || !editadoEm) {
    return <>{prefixo}.</>;
  }

  return (
    <>
      {prefixo} por:
      <br />
      {editadoPorNome} em {DataEHoraAmigavel(editadoEm)}.
    </>
  );
}

export default function ModalTarefaNotificacao({
  show,
  titulo,
  estado,
  editadoPorNome,
  editadoEm,
  onHide,
  onCriarTarefa,
  onAtender,
  loading = false,
}: ModalTarefaNotificacaoProps) {
  return (
    <Modal show={show} centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{titulo}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0 text-muted">
          {estado === 'sem_tarefa' &&
            'Ao criar uma tarefa, todos os usuários notificados sobre esse evento passam a acompanhar o mesmo atendimento.'}
          {estado === 'em_atendimento' && (
            <MensagemAutoria
              prefixo="A tarefa está em andamento"
              editadoPorNome={editadoPorNome}
              editadoEm={editadoEm}
            />
          )}
          {estado === 'atendida' && (
            <MensagemAutoria
              prefixo="Esta tarefa já foi concluída"
              editadoPorNome={editadoPorNome}
              editadoEm={editadoEm}
            />
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        {estado === 'sem_tarefa' && (
          <>
            <Button
              variant="outline-warning"
              onClick={() => onCriarTarefa(false)}
              disabled={loading}
            >
              Atender
            </Button>
            <Button
              variant="outline-success"
              onClick={() => onCriarTarefa(true)}
              disabled={loading}
            >
              Concluir
            </Button>
          </>
        )}
        {estado === 'em_atendimento' && (
          <Button variant="outline-success" onClick={onAtender} disabled={loading}>
            <i className="bi bi-clock me-1" aria-hidden />
            Marcar como atendida
          </Button>
        )}
        <Button variant="outline-secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
